import { actionCreator } from '@shared/actions/actions';
export const TileDataLoadingAction = 'TileDataLoadingAction';
export const createTileDataLoadingAction = actionCreator(TileDataLoadingAction);
export const TileDataReceivedAction = 'TileDataReceivedAction';
export const createTileDataReceivedAction = actionCreator(TileDataReceivedAction);
